import React, { Component } from "react";
import Banner from "./Banner";
import BannerTabNav from "./BannerTabNav";
import AgentContent from "./AgentContent";
// import Superoffers from "./Superoffers";
// import Event from "./Events/Event";
import AgentFooter from "./AgentFooter";
import "./Header.css";
import { Link, Redirect } from "react-router-dom";
import { Base64 } from "js-base64";
import {
  setCustomerLogin,
  getGeoInfo,
  getCustomerLogin,
  LoginConfirmation,
  LoginAgentConfirmation,
  ConfirmationForgot,
  HomePageEventData,
  getSpecialOffersForHome,
} from "./axios";
import Modal from "react-modal";
import FacebookLogin from "react-facebook-login";
import { GoogleLogin, GoogleLogout } from "react-google-login";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import moment from "moment";
import SignUp from "./SignUp";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import SkeletonHome from "./SkeletonHome";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const TabsArr = [
  "Accommodations",
  "Attractions & Things to Do",
  "Packages",
  "Land & Ferry Transfers",
  "Liveaboard",
];

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
class Header extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      nav: false,
      selected: "Accommodations",
      modalIsOpen: false,
      ChangeLoginScreenClass: "containerLogin",
      ChangeForgotScreenClass: 'containerForget',
      facebookLogin: false,
      facebookResponse: {},
      GoogleLoginButton: false,
      GoogleResponse: {},
      country: "",
      country_code: "",
      currency: "",
      ip_address: "",
      customerEmail: cookies.get("userDetails") || "",
      customerEmailForData: localStorage.getItem("userDetails") || "abc",
      customerDetails: {},
      profileNew: false,
      profileNewAgain: false,
      LoginEmail: "",
      LoginPassword: "",
      errorPassword: false,
      notActivePassword: false,
      OfferData: null,
      modalIsSecondOpen: false,
      ForgotEmail: "",
      errorForgotEmail: false,
    };
  }

  handleScroll = () => {
    if (window.pageYOffset > 40) {
      if (!this.state.nav) {
        this.setState({ nav: true });
      }
    } else {
      if (this.state.nav) {
        this.setState({ nav: false });
      }
    }
  };
  setSelectedTabOptions = (tab) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.setState({ selected: tab });
  };

  ChangeLoginEmail = (event) => {
    this.setState({ LoginEmail: event.target.value });
  };

  ChangeLoginPassword = (event) => {
    this.setState({ LoginPassword: event.target.value });
  };

  LoginConfirm = (e) => {
    e.preventDefault();
    this.setState({ errorPassword: false });
    this.setState({ notActivePassword: false });
    let emailNew = this.state.LoginEmail;
    let email = '';
    if (emailNew.length > 0) {
      email = emailNew;
    } else {
      email = this.state.customerEmail.email;
    }
    let password = this.state.LoginPassword;

    LoginAgentConfirmation(email, password).then(
      (data) => {
        console.log(data);
        // if (data == 'not_correct') {
        //   this.setState({ errorPassword: true });
        // } else {
          if (data == 'not_correct') {
            this.setState({ errorPassword: true });
        }else if (data = 'not_active') {
          this.setState({ notActivePassword: true });
        } else {
          this.setState({ customerDetails: data });

          let Verified = '';
          if (data.verified == 1) {
            Verified = true;
          }

          const dataSearch = {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            country_code: data.country_code,
            verified: Verified,
            uid: data.id
          }

          let JsonData = JSON.stringify(dataSearch);

          localStorage.setItem('userDetails', JsonData);
          window.location.reload(true);
        }

      },
      (error) => {

      });
  }

  //Ranjeet BY
  ChangeFogotEmail = (event) => {
    this.setState({ ForgotEmail: event.target.value });
  };


  ForgotConfirm = (e) => {
    e.preventDefault();
    let emailNew = this.state.ForgotEmail;
    if (validateEmail(emailNew)) {
      let email = "";
      if (emailNew.length > 0) {
        email = emailNew;
      }
      // let password = this.state.LoginPassword;

      ConfirmationForgot(email).then(
        (data) => {
          // console.log(data);
          if (data == "not_correct") {
            this.setState({ errorForgotEmail: true });
          } else {


            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          }
        },
        (error) => { }
      );
    } else {
      this.setState({ errorForgotEmail: true });
    }
  };


  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tabName = urlParams.get("t");

    if (tabName != null) {
      if (Base64.atob(tabName) == 1) {
        this.setState({ selected: "Accommodations" });
      } else if (Base64.atob(tabName) == 2) {
        this.setState({ selected: "Attractions & Things to Do" });
      } else if (Base64.atob(tabName) == 3) {
        this.setState({ selected: "Packages" });
      } else if (Base64.atob(tabName) == 4) {
        this.setState({ selected: "Land & Ferry Transfers" });
      } else if (Base64.atob(tabName) == 5) {
        this.setState({ selected: "Liveaboard" });
      }
    }

    let userData = localStorage.getItem("userDetails");
    getGeoInfo().then(
      (data) => {
        // console.log(data);
        this.setState({ country: data.country_name });
        this.setState({ country_code: data.country_calling_code });
        this.setState({ currency: data.currency });
        this.setState({ ip_address: data.ip });
      },
      (error) => { }
    );

    if (userData != null) {
      const { cookies } = this.props;

      let newData = JSON.parse(userData);
      getCustomerLogin(newData.email).then(
        (data) => {
          //   console.log(data);
          // this.setState({ customerDetails: data });

          // let Verified = "";
          // if (data.verified == 1) {
          //   Verified = true;
          // }

          // const dataSearch = {
          //   first_name: data.first_name,
          //   last_name: data.last_name,
          //   email: data.email,
          //   country_code: data.country_code,
          //   verified: Verified,
          //   uid: data.id,
          // };

          // let JsonData = JSON.stringify(dataSearch);

          // localStorage.setItem("userDetails", JsonData);
          this.setState({ customerDetails: data });
          if(data.user =='nouser'){
           let Verified = "";
           if (data.agent.verified == 1) {
             Verified = true;
           }
 
           const dataSearch = {
             first_name: data.agent.first_name,
             last_name: data.agent.last_name,
             email: data.agent.email,
             country_code: data.agent.country_code,
             verified: Verified,
             uid: data.agent.id,
             agent_id: data.agent.id,
           };
 
           let JsonData = JSON.stringify(dataSearch);
 
           localStorage.setItem("userDetails", JsonData);
          }else{
          
            let Verified = true;
         
           const dataSearch = {
             first_name: data.user.user_first_name,
             last_name: data.user.user_last_name,
             email: data.user.user_email,
             country_code: data.user.country_code,
             verified: Verified,
             uid: data.user.user_id,
             agent_id: data.agent.id,
           };
 
           let JsonData = JSON.stringify(dataSearch);
 
           localStorage.setItem("userDetails", JsonData);
          }
        },
        (error) => { }
      );
    }

    getSpecialOffersForHome().then(
      (data) => {
        // console.log(data);
        this.setState({ OfferData: data });
      },
      (error) => { }
    );

    window.addEventListener("scroll", this.handleScroll);
  }

  ChangeLoginScreen = () => {
    this.setState({
      ChangeLoginScreenClass: "containerLogin right-panel-active",
    });
  };
  ChangeLoginReverse = () => {
    this.setState({ ChangeLoginScreenClass: "containerLogin" });
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.globalClickListener);
  }

  globalClickListener = (nativeEvent) => {
    this.setState({ profileNew: false, profileNewAgain: false }, () => {
      // console.log("global click");
      // document.removeEventListener('click', this.globalClickListener)
      window.removeEventListener("click", this.globalClickListener);
    });
  };
  OpenProfilelink = (syntheticEvent) => {
    // console.log("toggle dropdown");
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ profileNew: !prevState.profileNew }),
      () => {
        if (this.state.profileNew) {
          // console.log(this.state.profileNew);

          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
    console.log(this.state.dropdownVisible);
  };
  OpenProfilelinkAgain = (syntheticEvent) => {
    // console.log("toggle dropdown");
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ profileNewAgain: !prevState.profileNewAgain }),
      () => {
        if (this.state.profileNewAgain) {
          // console.log(this.state.profileNewAgain);

          // document.addEventListener('click', this.globalClickListener)
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
    console.log(this.state.dropdownVisible);
  };

  openModal = () => {
    this.setState({ modalIsSecondOpen: false });
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  openSecondModal = () => {
    this.setState({ modalIsOpen: false });
    this.setState({ modalIsSecondOpen: true });

  }


  closeSecondModal = () => {
    this.setState({ modalIsSecondOpen: false });
  }

  LoginFaceBook = () => {
    // console.log("rohan");
    this.setState({ facebookLogin: true });
  };

  GoogleLoginOpen = () => {
    // console.log("rohan1");
    this.setState({ GoogleLoginButton: true });
  };

  addResponseData = (response) => {
    this.setState({ facebookResponse: response });
  };

  responseFacebook = (response) => {
    const { cookies } = this.props;
    // console.log(response);
    if (response.accessToken) {
      this.setState({ facebookResponse: response });
      let Name = response.first_name;

      let first_name = response.first_name;
      let last_name = response.last_name;
      let email = response.email;
      let profile_image = response.picture.data.url;
      let birthday = moment(response.birthday).format("Y-MM-DD");
      let gender = response.gender;
      let login_source = 1;

      let mobile_number = "";
      let country = this.state.country;
      let country_code = this.state.country_code;
      let currency = this.state.currency;
      let ip_address = this.state.ip_address;
      let password = "";
      let verified = 1;

      let Verified = "";
      if (verified == 1) {
        Verified = true;
      }

      const dataSearch = {
        first_name: first_name,
        last_name: last_name,
        email: email,
        country_code: country_code,
        verified: Verified,
        uid: "",
      };

      let JsonData = JSON.stringify(dataSearch);

      localStorage.setItem("userDetails", JsonData);
      cookies.set("userDetails", JsonData, { path: "/" });

      setCustomerLogin(
        first_name,
        last_name,
        email,
        profile_image,
        birthday,
        gender,
        login_source,
        mobile_number,
        country,
        country_code,
        currency,
        ip_address,
        password,
        verified
      ).then(
        (data) => {
          // console.log(data);
          if (data.id > 0) {
            window.location.reload(true);
          }
        },
        (error) => { }
      );
      this.setState({ modalIsOpen: false });
      window.location.reload(true);
    }
  };

  responseGoogle = (response) => {
    // console.log(response);
    if (response.accessToken) {
      const { cookies } = this.props;
      this.setState({ GoogleResponse: response });

      let first_name = response.profileObj.givenName;
      let last_name = response.profileObj.familyName;
      let email = response.profileObj.email;
      let profile_image = response.profileObj.imageUrl;
      let birthday = "";
      let gender = "";
      let login_source = 2;

      let mobile_number = "";
      let country = this.state.country;
      let country_code = this.state.country_code;
      let currency = this.state.currency;
      let ip_address = this.state.ip_address;
      let password = "";
      let verified = 1;

      let Verified = "";
      if (verified == 1) {
        Verified = true;
      }

      const dataSearch = {
        first_name: first_name,
        last_name: last_name,
        email: email,
        country_code: country_code,
        verified: Verified,
        uid: "",
      };

      let JsonData = JSON.stringify(dataSearch);

      localStorage.setItem("userDetails", JsonData);
      cookies.set("userDetails", JsonData, { path: "/" });

      setCustomerLogin(
        first_name,
        last_name,
        email,
        profile_image,
        birthday,
        gender,
        login_source,
        mobile_number,
        country,
        country_code,
        currency,
        ip_address,
        password,
        verified
      ).then(
        (data) => {
          // console.log(data);
          if (data.id > 0) {
            window.location.reload(true);
          }
        },
        (error) => { }
      );
      this.setState({ modalIsOpen: false });
      // window.location.reload(true);
    }
  };

  logoutChange = () => {
    localStorage.clear();
    window.location.reload(true);
  };

  render() {
   
    return (
      // <div id="page" className="bgGradient">
      //   <div className='mobile-menu'>

      //   </div>
      //   <div className="">
      //     <div className="container">
      //       <div className="row">
      //         <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12">
      //           <div className="logo">
      //             <a className="">
      //               <img
      //                 src="images/logo/seyLogo.png"
      //                 alt="Holiday Seychelles"
      //               />
      //             </a>
      //           </div>

      //         </div>


      //         <div className="col-md-9 col-lg-9 col-sm-12 col-xs-12">
      //           <ul id="top_menu">
      //             <li><a href="/agentlogin" id="" class="Create" title="Create account">Sign In</a></li>
      //             <li><a href="/agentsignup" id="" class="account" title="Create account">Create Account</a></li>
      //           </ul>
      //         </div>
      //       </div>

      //       <div className="hsFlex_Bann hsCenter prependTop5 appendBottom40 mobile-view"> </div>

      //       <div className="header-top-section">
      //         <div
      //           className={`chHeaderWrapper ${this.state.nav == true ? " stickyHeader" : " navOnly"
      //             }`}
      //         >
      //           <div className="chHeaderContainer">
      //             <span className="logoContainer">
      //               <a className="chMmtLogo" href="/">
      //                 <img
      //                   src="images/logo/seyLogo.png"
      //                   alt="Holiday Seychelles"

      //                 />
      //               </a>
      //             </span>


      //           </div>
      //         </div>
      //       </div>

      //     </div>

      //   </div>

      //   <AgentContent/>

      //   <AgentFooter
      //     showNews={"News"}
      //     tabs={TabsArr}
      //     selected={this.state.selected}
      //     setSelectedTab={this.setSelectedTabOptions}
      //   />{" "}
      // </div>
      <div id="page" class="bgGradient">
<header class="header menu_fixed">
  <div class="container">
    <div id="preloader">
      <div data-loader="circle-side"></div>
    </div>
    <div id="logo"> 
    <a href=""> <img src="images/logo/seyLogo.png" alt="Holiday Seychelles" class="logo_normal" /> 
    <img src="images/logo/seyLogo.png" alt="" class="logo_sticky"/> </a> </div>
    <ul id="top_menu">
      {/* <?php if($userId > 0){ ?>
        <li><a href="<?php echo base_url(); ?>grouphome" id="" class="account" title="Dashboard">Dashboard</a></li>
     <?php }else { ?>
      <li><a href="<?php echo base_url(); ?>login" id="" class="Create" title="Create account">Sign In</a></li>
      <li><a href="<?php echo base_url(); ?>login/signup" id="" class="account" title="Create account">Create Account</a></li>
     <?php } ?> */}
      <li><a href="/agentlogin" id="" class="account" title="Create account">Sign In</a></li>
      <li><a href="/agentsignup" id="" class="account" title="Create account">Create Account</a></li>
      
    </ul>
  
    <a href="#menu" class="btn_mobile">
    <div class="hamburger hamburger--spin" id="hamburger">
      <div class="hamburger-box">
        <div class="hamburger-inner"></div>
      </div>
    </div>
    </a>
    
  </div>
</header>
<AgentContent/>

  <AgentFooter
    showNews={"News"}
    tabs={TabsArr}
    selected={this.state.selected}
    setSelectedTab={this.setSelectedTabOptions}
  />{" "}
  </div>
    );
  }
}

export default withCookies(Header);
